import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import { timezoneList } from "util/constants";

dayjs.extend(utc);
dayjs.extend(tz);

/** IANA id from API timezone label string, Redux user slice, or raw IANA string. */
export function getUserIanaTimezone(userReducerOrTimezoneLabel) {
  const tzLabel =
    typeof userReducerOrTimezoneLabel === "string"
      ? userReducerOrTimezoneLabel
      : userReducerOrTimezoneLabel?.timezone || "";
  return timezoneList[tzLabel] || (tzLabel.includes("/") ? tzLabel : null) || "UTC";
}

/** Format UTC ISO timestamps using DB-backed label (or Redux fallback). */
export function formatInUserTimezone(isoString, userReducerOrTimezoneLabel, format) {
  if (isoString == null || isoString === "") return "";
  return dayjs
    .utc(isoString)
    .tz(getUserIanaTimezone(userReducerOrTimezoneLabel))
    .format(format);
}
